<div class="atn-platform">
  <atn-navbar />

  <div
    class="atn-platform__body"
    [style.margin-left.px]="navbarStore.dedicatedWidthSg()"
  >
    <router-outlet />

    @if (navigationFeature.selectors.isTransitioning.asSignal()) {
      <div
        class="atn-platform__transition-loader"
        role="status"
        aria-live="polite"
      >
        <div class="atn-platform__transition-content">
          <div
            class="atn-platform__transition-bar"
            aria-hidden="true"
          >
            <span></span>
          </div>
          <div class="atn-platform__transition-message">
            {{ transitionMessageSg() }}
          </div>
        </div>
      </div>
    }
  </div>

  <atn-platform-floaters />
</div>
